const getIsoFromDate = (datum) => {
	const isoDateTime = new Date(datum.getTime() - (datum.getTimezoneOffset() * 60000)).toISOString();
	return isoDateTime;
};

export default getIsoFromDate;